import { render, staticRenderFns } from "./AuthFormComponent.vue?vue&type=template&id=04f935b0"
import script from "./AuthFormComponent.vue?vue&type=script&lang=js"
export * from "./AuthFormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports